import { cn } from './cn';

type Props = { children: string; tone?: 'dark' | 'light'; className?: string };

/** Petit titre en majuscules précédé d'un trait qui déborde à gauche. */
export default function Eyebrow({ children, tone = 'dark', className }: Props) {
  return (
    <div className={cn('relative flex items-center text-xs font-semibold uppercase tracking-[0.0625rem]', tone === 'light' ? 'text-white' : 'text-ink', className)}>
      <span aria-hidden className={cn('absolute right-full mr-6 hidden h-px w-12 lg:block', tone === 'light' ? 'bg-brand' : 'bg-charcoal')} />
      <span>{children}</span>
    </div>
  );
}
